import React from "react";
import PropTypes from "prop-types";

const Heading = (props) => {
  const { text } = props.config;
  return (
    <React.Fragment>
      <hr />
      <h2>{text}</h2>
    </React.Fragment>
  );
};

Heading.propTypes = {
  config: PropTypes.object.isRequired,
};

export default Heading;



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Content/Heading.js